import { serviceRouteConstants } from "@/Constants/routingConstants";

import { post } from ".";
import { systemAllRequests } from "../utilities/utils";

/**
 * Asynchronous function to fetch client invoices.
 *
 * @param {Object} data - The data to be sent with the request.
 * @return {Promise} A promise that resolves with the result of the post request.
 */

export const _fetchClientInvoices = async (data) => {
  let candidateId = data.candidateId;
  let invoiceDateFrom = data.invoiceDateFrom;
  let invoiceDateTo = data.invoiceDateTo;
  let dueDateFrom = data.dueDateFrom;
  let dueDateTo = data.dueDateTo;
  let contractReferenceNo = data.contractReferenceNo;
  let invoiceReferenceNo = data.invoiceReferenceNo;
  let invoiceStatus = data.invoiceStatus;
  let sessionType = data.sessionType;
  let roleId = data.candidateRole;
  let licenceNo = data.licenseNo;
  let search = data.search;
  let currentPage = data.currentPage;
  let sortByColumn = data.sortByColumn;
  let sortByOrder = data.sortByOrder;

  if (invoiceDateFrom && invoiceDateFrom !== "") {
    invoiceDateFrom = invoiceDateFrom.split("/").reverse().join("-");
  }

  if (invoiceDateTo && invoiceDateTo !== "") {
    invoiceDateTo = invoiceDateTo.split("/").reverse().join("-");
  }

  if (dueDateFrom && dueDateFrom !== "") {
    dueDateFrom = dueDateFrom.split("/").reverse().join("-");
  }

  if (dueDateTo && dueDateTo !== "") {
    dueDateTo = dueDateTo.split("/").reverse().join("-");
  }

  if (candidateId && (candidateId !== "" || candidateId.length > 0)) {
    candidateId = candidateId.join(",");
  }

  if (sessionType && (sessionType !== "" || sessionType.length > 0)) {
    sessionType = sessionType.join(",");
  }

  if (invoiceStatus && (invoiceStatus !== "" || invoiceStatus.length > 0)) {
    invoiceStatus = invoiceStatus.join(",");
  }

  let postData = {
    candidateId: candidateId,
    search: search,
    invoiceDateFrom: invoiceDateFrom,
    invoiceDateTo: invoiceDateTo,
    dueDateFrom: dueDateFrom,
    dueDateTo: dueDateTo,
    contractReferenceNo: contractReferenceNo,
    invoiceReferenceNo: invoiceReferenceNo,
    invoiceStatus: invoiceStatus,
    sessionType: sessionType,
    roleId: roleId,
    licenceNo: licenceNo,
    page: currentPage,
    sortByColumn: sortByColumn,
    sortByOrder: sortByOrder,
  };

  systemAllRequests({
    request: postData,
    pageOfRequest: "applocum_invoice",
    crmRoute: "get_invoice_list",
    method: "POST",
    page: "applocum_invoice",
  });
  const request = {
    endPoint: serviceRouteConstants.invoice,
    data: postData,
  };
  return await post(request);
};

export const _fetchCandidatePayInvoices = async (data) => {
  let candidateId = data.candidateId;
  let invoiceDateFrom = data.invoiceDateFrom;
  let invoiceDateTo = data.invoiceDateTo;
  let dueDateFrom = data.dueDateFrom;
  let dueDateTo = data.dueDateTo;
  let contractReferenceNo = data.contractReferenceNo;
  let invoiceReferenceNo = data.invoiceReferenceNo;
  let invoiceStatus = data.invoiceStatus;
  let sessionType = data.sessionType;
  let roleId = data.candidateRole;
  let licenceNo = data.licenseNo;
  let search = data.search;
  let currentPage = data.currentPage;
  let sortByColumn = data.sortByColumn;
  let sortByOrder = data.sortByOrder;

  if (invoiceDateFrom && invoiceDateFrom !== "") {
    invoiceDateFrom = invoiceDateFrom.split("/").reverse().join("-");
  }

  if (invoiceDateTo && invoiceDateTo !== "") {
    invoiceDateTo = invoiceDateTo.split("/").reverse().join("-");
  }

  if (dueDateFrom && dueDateFrom !== "") {
    dueDateFrom = dueDateFrom.split("/").reverse().join("-");
  }

  if (dueDateTo && dueDateTo !== "") {
    dueDateTo = dueDateTo.split("/").reverse().join("-");
  }

  if (candidateId && (candidateId !== "" || candidateId.length > 0)) {
    candidateId = candidateId.join(",");
  }

  if (sessionType && (sessionType !== "" || sessionType.length > 0)) {
    sessionType = sessionType.join(",");
  }

  if (invoiceStatus && (invoiceStatus !== "" || invoiceStatus.length > 0)) {
    invoiceStatus = invoiceStatus.join(",");
  }

  let postData = {
    candidateId: candidateId,
    search: search,
    invoiceDateFrom: invoiceDateFrom,
    invoiceDateTo: invoiceDateTo,
    dueDateFrom: dueDateFrom,
    dueDateTo: dueDateTo,
    contractReferenceNo: contractReferenceNo,
    invoiceReferenceNo: invoiceReferenceNo,
    invoiceStatus: invoiceStatus,
    sessionType: sessionType,
    roleId: roleId,
    licenceNo: licenceNo,
    page: currentPage,
    sortByColumn: sortByColumn,
    sortByOrder: sortByOrder,
  };

  systemAllRequests({
    request: postData,
    pageOfRequest: "candidate_pay_invoice",
    crmRoute: "get_candidate_invoice_list",
    method: "POST",
    page: "candidate_pay_invoice",
  });

  const request = {
    endPoint: serviceRouteConstants.candidatePayIncvoice,
    data: postData,
  };
  return await post(request);
};

export const _fetchInovoicesCount = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.invoiceCount,
    data: data,
  };
  return await post(request);
};

export const _updateCandidatePayStatusData = async (data) => {
  const { invoice_id, isSelectedAll, ignoreIds } = data;
  const postData = {
    invoice_id: invoice_id,
    isSelectedAll: isSelectedAll,
    ignoreIds: ignoreIds,
  };
  const request = {
    endPoint: serviceRouteConstants?.UpdateCandidatePayStatus,
    data: postData,
  };
  return await post(request);
};
